/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import {
  COLLAPSE_DEFINITION_METHOD,
  INCLUDE_COLLAPSE,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { COLLAPSE_METHOD_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';
import { modelTypesByForm, MODEL_TYPE_2_ID } from '#src/js/constants/models/modelTypes/index.js';
import {
  selectRunOutputProbCollapseMce,
  selectRunOutputCollapseCapacityMedian,
} from '#selectors/entities/models.js';
import BuildingStabilityView from './BuildingStabilityView.jsx';

const { COLLAPSE_METHOD_FEMA, COLLAPSE_METHOD_MCE, COLLAPSE_METHOD_MEDIAN } =
  COLLAPSE_METHOD_VALUES;

const mapStateToProps = (state, ownProps) => {
  const { modelId, form, modelType } = ownProps;
  const { selectFormValues, selectIsCountryJapan } = modelTypesByForm[form];

  const collapseDefinitionMethod = selectFormValues(state, COLLAPSE_DEFINITION_METHOD);
  const showMessage = !selectFormValues(state, INCLUDE_COLLAPSE);
  const isJapan = selectIsCountryJapan(state);

  const probCollapseMce = selectRunOutputProbCollapseMce(state, { modelId });
  const collapseCapacityMedian = selectRunOutputCollapseCapacityMedian(state, { modelId });

  const showProbCollapseMceRO =
    !isJapan &&
    modelType === MODEL_TYPE_2_ID &&
    [COLLAPSE_METHOD_FEMA, COLLAPSE_METHOD_MEDIAN].includes(collapseDefinitionMethod);

  const showCollapseMedianRO =
    !isJapan &&
    modelType === MODEL_TYPE_2_ID &&
    [COLLAPSE_METHOD_FEMA, COLLAPSE_METHOD_MCE].includes(collapseDefinitionMethod);

  return {
    showProbCollapseMceRO,
    showCollapseMedianRO,
    probCollapseMce,
    collapseCapacityMedian,
    showMessage,
  };
};
export default connect(mapStateToProps)(BuildingStabilityView);
